import { OrdersModule } from '@/shared';

export default OrdersModule;
